import { Menu } from '@base-ui-components/react/menu'

export const MenuRadioGroup = Menu.RadioGroup
